import { Component, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-job-order',
    templateUrl: './job-order.component.html',
    styleUrls: ['./job-order.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, TranslatePipe]
})
export class JobOrderComponent {
  @Output() orderChanged = new EventEmitter();
  public filter: any;
  public showDropdown = false;

  public orderBy = [
    'OrderAZ',
    'OrderZA',
    'DateAsc',
    'DateDesc'
  ]

  selectOrder() {
    let orderField = null;
    switch (this.filter) {
      case 'OrderAZ': orderField = 'name'; break;
      case 'OrderZA': orderField = '-name'; break;
      case 'DateAsc': orderField = 'releasedDate'; break;
      case 'DateDesc': orderField = '-releasedDate'; break;
      default: orderField = 'name'; break;
    }
    this.orderChanged.emit(orderField);
  }

}
